var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKaka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 110,
    viewBox: "0 0 108 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2087 2H52.085C52.4901 2 52.8174 2.33507 52.83 2.74095C53.3361 19.0439 70.4808 27.4929 79.5236 29.8305C79.7943 29.9005 79.9985 30.1188 80.0623 30.3916C84.1789 47.9982 98.1784 53.9601 105.332 54.8669C105.709 54.9148 106 55.2313 106 55.6125V59.8224C106 63.8626 105.051 67.846 103.23 71.4502L95.6536 86.4434C93.0878 91.5211 88.915 95.6029 83.7881 98.05L68.1795 105.5C63.4328 107.766 58.1066 108.516 52.9207 107.65L38.088 105.172C32.8758 104.301 28.0586 101.84 24.2938 98.1231L12.0314 86.018C8.03543 82.0734 5.43806 76.9257 4.63628 71.3618L2.26374 54.8979C1.50905 49.6609 2.38328 44.318 4.76732 39.597L12.5427 24.1998C14.8868 19.5578 18.5797 15.737 23.1342 13.2413L37.8938 5.15378C41.6701 3.08449 45.9049 2 50.2087 2Z",
    stroke: "#FFF9DE",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8277 66.3355C85.8277 69.3811 83.3646 71.85 80.3262 71.85C77.2878 71.85 74.8247 69.3811 74.8247 66.3355C74.8247 63.2899 77.2878 60.821 80.3262 60.821C83.3646 60.821 85.8277 63.2899 85.8277 66.3355Z",
    stroke: "#FFF9DE",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8155 74.4234C41.8155 77.469 39.3524 79.9379 36.3139 79.9379C33.2755 79.9379 30.8124 77.469 30.8124 74.4234C30.8124 71.3778 33.2755 68.9089 36.3139 68.9089C39.3524 68.9089 41.8155 71.3778 41.8155 74.4234Z",
    stroke: "#FFF9DE",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1508 36.925C49.1508 39.9705 46.6877 42.4395 43.6493 42.4395C40.6109 42.4395 38.1478 39.9705 38.1478 36.925C38.1478 33.8794 40.6109 31.4105 43.6493 31.4105C46.6877 31.4105 49.1508 33.8794 49.1508 36.925Z",
    stroke: "#FFF9DE",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaka);
export default __webpack_public_path__ + "static/media/kaka.afb7663a2528427006a646b8efcd7bd3.svg";
export { ForwardRef as ReactComponent };